<div class="news-card-list-component-container">
  <div *ngIf="personalNewsItems" class="row">
    <div *ngFor="let newsItem of personalNewsItems" class="col-12 col-lg-6 col-xxl-4 mt-4 overflow-hidden">
      <div class="card front flex-row">
        <div class="col-sm-5 p-0 card-img-container" *ngIf="newsItem.Picture && !newsItem.Picture.endsWith('sitepagethumbnail.png')">
          <a href="{{newsItem.Path}}" i18n-aria-label="news read the news article@@news-read-the-news-article" aria-label="read the news article" title="{{newsItem.Title}}" class="your-news-clickable-link">
            <div class="w-100 h-100">
              <img #newsImageEl [appImgSrcProxy]="newsItem.Picture" *ngIf="newsItem.IsSharePointNews; else lightNewsImage" class="news-img" alt="{{newsItem.Title}}" [ngStyle]="setFallBackStyle(newsImageEl)" />
              <!-- Because WP Light news have full image urls and don't have to go through appImgSrcProxy -->
              <ng-template #lightNewsImage>
                <img #newsImageEl src="{{newsItem.Picture}}" *ngIf="newsItem.Picture" class="news-img" title="{{newsItem.Title}}" alt="{{newsItem.Title}}" [ngStyle]="setFallBackStyle(newsImageEl)" />
              </ng-template>
            </div>
          </a>
          <div class="img-overlay" *ngIf="showNewsDesc">
            <button mat-flat-button aria-label="{{newsItem.Title}}" color="accent" class="quick-view news-quick-view-btn" (click)="showNewsDescription(newsItem)">
              <span class="small" i18n="news quick view@@news-quick-view"><i class="fa fa-chevron-circle-up" aria-hidden="true"></i> Quick read</span>
            </button>
          </div>
        </div>
        <div class="img-overlay" *ngIf="showNewsDesc && (!newsItem.Picture || newsItem.Picture.endsWith('sitepagethumbnail.png'))">
          <button mat-flat-button aria-label="{{newsItem.Title}}" color="accent" class="quick-view news-quick-view-btn" (click)="showNewsDescription(newsItem)">
            <span class="small" i18n="news quick view@@news-quick-view"><i class="fa fa-chevron-circle-up" aria-hidden="true"></i> Quick read</span>
          </button>
        </div>
        <div class="card-body d-flex flex-column" [ngClass]="newsItem.Picture && !newsItem.Picture.endsWith('sitepagethumbnail.png') ? 'col-sm-7' : 'col-12 news-item-bg-color'">
          <div class="card-site-title metadata-text mb-2">
            <div *ngIf="newsItem.SiteInfo$ | async as siteInfo; else sitename">
              <a href="{{siteInfo.webUrl}}" attr.aria-label="{{siteInfo.displayName}}">{{siteInfo.displayName}}</a>
            </div>
            <ng-template #sitename>
              <div *ngIf="newsItem.SiteName">
                <a href="{{newsItem.SiteUrl}}" attr.aria-label="{{newsItem.SiteName}}">{{newsItem.SiteName}}</a>
              </div>
            </ng-template>
          </div>
          <div *ngIf="!showChannelTagsPrintout[newsItem.Path]" class="card-subtitle metadata-text">
            <span>{{newsItem.PublishedDate | formatDate:false}}</span>
            <ng-container *ngIf="newsItem.PageInfo$ | async as pageInfo; else newsItemInfo">
              <span *ngIf="!featureSettings.hideNewsLikes || (featureSettings.hideNewsLikes === 'HideIfNoLikes' && pageInfo.LikesCount > 0)">
                <i aria-label="Number of Likes" i18n-aria-label="@@number-of-likes" role="img" alt="Number of Likes" class="fa fa-heart mr-2 ml-2"></i>
                <span>{{pageInfo.LikesCount}}</span>
              </span>
              <span *ngIf="!featureSettings.hideNewsComments || (featureSettings.hideNewsComments === 'HideIfNoComments' && pageInfo.CommentsCount > 0)">
                <i aria-label="Number of Comments" i18n-aria-label="@@number-of-comments" role="img" alt="Number of Comments" class="fa fa-comment mr-2 ml-2"></i>
                <span>{{pageInfo.CommentsCount}}</span>
              </span>
           </ng-container>
           <ng-template #newsItemInfo>
              <span *ngIf="(!featureSettings.hideNewsLikes && newsItem.IsSharePointNews) || (featureSettings.hideNewsLikes === 'HideIfNoLikes' && newsItem.LikesCount > 0) || (!newsItem.IsSharePointNews && newsItem.LikesCount > 0)">
                <i aria-label="Number of Likes" i18n-aria-label="@@number-of-likes" role="img" alt="Number of Likes" class="fa fa-heart mr-2 ml-2"></i>
                <span>{{newsItem.LikesCount}}</span>
              </span>
              <span *ngIf="(!featureSettings.hideNewsComments && newsItem.IsSharePointNews) || (featureSettings.hideNewsComments === 'HideIfNoComments' && newsItem.CommentsCount > 0 || (!newsItem.IsSharePointNews && newsItem.CommentsCount > 0))">
                <i aria-label="Number of Comments" i18n-aria-label="@@number-of-comments" role="img" alt="Number of Comments" class="fa fa-comment mr-2 ml-2"></i>
                <span>{{newsItem.CommentsCount}}</span>
              </span>
           </ng-template>
            <!-- News channel tag icon -->
            <span *ngIf="!featureSettings.hideNewsTags && newsItem.Channels && newsItem.Channels.length > 0" (click)="showChannelTagsPrintoutClick(newsItem)" title="{{getChannelsString(newsItem)}}">
              <i class="fa fa-tag mr-2 ml-2"></i>
            </span>
          </div>
          <!-- Printout of news tags since no other way to see them on mobile -->
          <div *ngIf="showChannelTagsPrintout[newsItem.Path]" class="card-subtitle metadata-text" (click)="showChannelTagsPrintoutClick(newsItem)">
            <!-- News channel tag icon -->
            <span>
              <i class="fa fa-tag mr-2 ml-2"></i>
            </span>
            {{getChannelsString(newsItem)}}
          </div>
          <a href="{{newsItem.Path}}" class="card-title mb-0" i18n-aria-label="news read the news article@@news-read-the-news-article" aria-label="read the news article" title="{{newsItem.Title}}">
            <h4 class="h55 mb-0 extra-bold" *ngIf="newsItem.Title">{{newsItem.Title}}</h4>
          </a>
          <div *ngIf="newsItem.SenderTags" class="mt-auto justify-content-end">
            <div class="text-right" [ngClass]="newsItem.Picture && !newsItem.Picture.endsWith('sitepagethumbnail.png') ? 'accent-1-color' : 'card-sendertag'">
              <span>{{getSenderTagString(newsItem)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card back flex-row" *ngIf="showNewsDesc && newsItem.hide" @slideInOut>
        <div class="card-body col-12">
          <div class="img-overlay d-flex flex-row">
            <div class="mb-1">
              <button mat-flat-button aria-label="{{newsItem.Title}}" color="accent" class="quick-view news-quick-view-btn mr-2" (click)="showNewsDescription(newsItem)" *ngIf="showNewsDesc">
                <span class="small" i18n="news quick view@@news-quick-view"><i class="fa fa-chevron-circle-down" aria-hidden="true"></i> Quick read</span>
              </button>
            </div>
            <div class="align-self-center">
              <a href="{{newsItem.Path}}" class="card-title" i18n-aria-label="news read the news article@@news-read-the-news-article" aria-label="read the news article" title="{{newsItem.Title}}">
                <h4 class="h55 mb-0 extra-bold" *ngIf="newsItem.Title">{{newsItem.Title}}</h4>
              </a>
            </div>
          </div>
          <div class="news-description">
            <span class="small">
              {{newsItem.Description}}
            </span>
          </div>
          <span>
            <app-action-link [href]="newsItem.Path" [target]="'blank'" *ngIf="newsItem.IsSharePointNews">
              <span i18n="open news page in sp@@open-news-page-in-sp" class="small">Open this page in sharepoint</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
            </app-action-link>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

